import styles from "./AppFramePageContent.module.scss"
import { AppFramePageContentProps } from "./AppFramePageContent.types"

export default function AppFramePageContent(props: AppFramePageContentProps) {
    const { children } = props

    return <div className={`${styles.base} main`}>{children}</div>
}
